module.exports = __webpack_public_path__ + "img/id_bubble.4403896.png";